import { Popup, ErrorPopup, httpAxios } from "../../core/classes/BaseStore";
import Vue from "vue";
import {
  BaseApiRoutes,
  BaseApiGetters,
  ApiAsyncHelper,
} from "@/modules/core/classes/Api";

import { NewsEntryItem } from "@/modules/news/viewmodels/NewsEntryItem";

export const state = {
  newsEntryItems: [],
};

export const getters = Object.assign(
  {
    newsEntryItems: (state) => {
      return state.newsEntryItems;
    },
    newsEntryItem: (state) => (Id) => {
      return state.newsEntryItems.find((e) => e.id === Id);
    },
    itemsOfEntry: (state) => (Id) => {
      return state.newsEntryItems.filter((e) => e.news_entry_id === Id);
    },
  },
  new BaseApiGetters(
    process.env.VUE_APP_BASE_URL + "/api/news-entry-items",
    NewsEntryItem,
    {
      AfterGetAll: (name, data) => {
        state.newsEntryItems = data;
        return data;
      },
      AfterShow: (name, data) => {
        let el = state.newsEntryItems.find((e) => e.id === data.id);
        if (el) {
          el = data;
        } else {
          state.newsEntryItems.push(data);
        }
        return data;
      },
      AfterCreate: (name, data) => {
        state.newsEntryItems.push(data);
        return data;
      },
      AfterDestroy: (name, data) => {
        let elementIndex = state.newsEntryItems.findIndex((e) => e.id === data);

        if (elementIndex !== null) {
          state.newsEntryItems.splice(elementIndex, 1);
        }

        return data;
      },
    },
    {
      /**
       * Searches for activities
       * this.$store.getters['activity/api'].Custom.ShowItemsOfEntry()
       */
      ShowItemsOfEntry: async (Id) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.get(
          process.env.VUE_APP_BASE_URL + "/api/news-entries/" + Id + "/items"
        );
        let data = ApiResult.data.data.map((e) => {
          return new NewsEntryItem(e);
        });

        state.newsEntryItems = data;

        return data;
      },
      /**
       * Move item
       * this.$store.getters['newsentryitem/api'].Custom.Move()
       */
      Move: async (Payload) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.get(
          process.env.VUE_APP_BASE_URL +
            "/api/news-entry-items/" +
            Payload.id +
            "/move",
          Payload
        );
        let data = ApiResult.data.data.map((e) => {
          return new NewsEntryItem(e);
        });

        let el = state.newsEntryItems.find((e) => e.id === data.id);
        el = data;

        return data;
      },

      /**
       * Reorder items
       * this.$store.getters['newsentryitem/api'].Custom.ReorderItems()
       */
      ReorderItems: async (Payload) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api
          .call(
            "post",
            process.env.VUE_APP_BASE_URL +
              "/api/news-entries/" +
              Payload.id +
              "/items-reorder",
            Payload
          )
          .catch((err) => {
            throw Error(err);
          });

        let data = ApiResult.map((Entry) => {
          return new NewsEntryItem(Entry);
        });

        Vue.set(state, "newsEntryItems", data);

        return data;
      },
    }
  )
);

// mutations
export const mutations = {
  reorderItems: (state, Items) => {
    Vue.set(state, "newsEntryItems", Items);
  },
};

export const actions = new BaseApiRoutes(
  process.env.VUE_APP_BASE_URL + "/api/news-entry-items",
  [],
  {
    async reorderItems({ commit }, Items) {
      commit("reorderItems", Items);
    },
  }
);
